import { post, get } from '@/@public/http/request'
export const Servicer = {
  getQaDetail: params => get(`/applets/helpCenter/answer`, params),
  getPicSrcList: params => post('/applets/helpCenter/getImgUrlBatch', params)
}
